/*
 *  Copyright (C) 2007 Free Software Foundation, Inc. <https://fsf.org/>
 *  This file (history.js) is part of LiteFarm.
 *
 *  LiteFarm is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  LiteFarm is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 *  GNU General Public License for more details, see <https://www.gnu.org/licenses/>.
 */

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

// Temporary `back()` shim for backward compatibility.
// We were previously using history@5, but downgraded to history@4 to be compatible with React Router v5.1.
// `goBack()` is the correct method in v4, so this shim ensures existing history.back() calls continue to work.
// TODO: LF-4242 Remove when upgrading to history@5.
history.back = () => history.goBack();

export default history;
